export default __webpack_public_path__ + "static/media/grafema_+-identity_07.a0db9d52.jpg";